import { render, staticRenderFns } from "./OpeningHoursSchedule.vue?vue&type=template&id=54bcb161&scoped=true"
import script from "./OpeningHoursSchedule.vue?vue&type=script&lang=js"
export * from "./OpeningHoursSchedule.vue?vue&type=script&lang=js"
import style0 from "./OpeningHoursSchedule.vue?vue&type=style&index=0&id=54bcb161&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bcb161",
  null
  
)

export default component.exports